<template>
  <v-autocomplete
    :items="representantes"
    :loading="loading"
    :search-input.sync="search"
    item-text="nome"
    item-value="id"
    label="Representantes"
    hide-no-data
    hide-selected
    v-model="model"
    @change="selecionarRepresentante"
  />
</template>

<script>
import api from '../../api'

export default {
  name: 'FiltroRepresentante',
  data() {
    const representantesInicial = [
      {
        id: null,
        nome: 'Todos os representantes'
      }
    ]
    return {
      representantesInicial,
      representantes: representantesInicial,
      model: null,
      loading: false,
      buscador: null,
      search: null,
      selected: false
    }
  },
  watch: {
    search() {
      if (this.search === null || this.search === 'Todos os representantes') {
        return
      }
      if (this.selected) {
        this.selected = false
        return
      }
      if (this.buscador !== null) {
        clearTimeout(this.buscador)
      }
      this.buscador = setTimeout(this.buscarRepresentantes, 1000)
    }
  },
  methods: {
    async buscarRepresentantes() {
      let representantes
      try {
        this.loading = true
        this.representantes = this.representantesInicial
        const response = await api.post('/', {
          query: `{ representantes(nome: "${this.search}") { id nome } }`
        })
        representantes = response.data.data.representantes
      }
      catch {
        representantes = []
      }
      finally {
        this.representantes = this.representantes.concat(representantes)
        this.loading = false
      }
    },
    selecionarRepresentante(value) {
      this.$emit('filtrar-representante', {
        representante: value
      })
      this.selected = true
    }
  }
}
</script>
